// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */
.container {
    font-family: Arial, sans-serif;
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
  }
  
  h1 {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .columns {
    display: flex;
    justify-content: space-between;
  }
  
  .column {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .issue-card {
    width: 300px;
    height: 200px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  
  .issue-card p {
    margin: 0;
    text-align: center;
  }
  
  .column h2 {
    text-align: center;
    margin-bottom: 10px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/QuickNavigation.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;IACI,8BAA8B;IAC9B,aAAa;IACb,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB","sourcesContent":["/* App.css */\n.container {\n    font-family: Arial, sans-serif;\n    padding: 20px;\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  \n  h1 {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  \n  .columns {\n    display: flex;\n    justify-content: space-between;\n  }\n  \n  .column {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .issue-card {\n    width: 300px;\n    height: 200px;\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    padding: 10px;\n    margin-bottom: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .issue-card p {\n    margin: 0;\n    text-align: center;\n  }\n  \n  .column h2 {\n    text-align: center;\n    margin-bottom: 10px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
